import { render, staticRenderFns } from "./CouponView.vue?vue&type=template&id=e34a2686&scoped=true"
import script from "./CouponView.vue?vue&type=script&lang=js"
export * from "./CouponView.vue?vue&type=script&lang=js"
import style0 from "./CouponView.vue?vue&type=style&index=0&id=e34a2686&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e34a2686",
  null
  
)

export default component.exports